module.exports = __webpack_public_path__ + "media/bootstrap-icons/save-fill-2386494c.svg";